const ApplyForms = () => {};

export default ApplyForms;
